import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import StickyMobileCtaBar from "@/components/StickyMobileCtaBar";
import ScrollProgress from "@/components/ScrollProgress";
import ClientWelcomeModal from "@/components/ClientWelcomeModal";

export const Layout = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen bg-[#0B0B0C] text-white flex flex-col">
      <ScrollProgress />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
      <StickyMobileCtaBar />
      <ClientWelcomeModal />
    </div>
  );
};

export default Layout;
